export const getNameOptionResponseFromFragmentName = (fragmentLink: any) =>
    fragmentLink ? Object.keys(fragmentLink.__fragments)[0].replace('Fragment', '')
        : ''

export const highlightSearchText = (text: string, search: string): React.ReactNode => {
    if (!search) return text;
    const regex = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'); // экранируем спецсимволы
    const parts = text.split(regex);

    return parts.map((part, i) =>
        part.toLowerCase() === search.toLowerCase() ? (
            <span key={i} style={{ background: 'yellow' }}>{part}</span>
            ) : (
        part
    )
);
}
